import React from 'react';
import PropTypes from 'prop-types';
import Panel from 'panelComponents/Panel';
import { Tabs, Tab } from 'material-ui/Tabs';
import CommentPanel from 'commentComponents/CommentPanel';

class MemoPanel extends React.PureComponent {

    constructor(props, context) {
        super(props, context);

        this.handleChange = this
            .handleChange
            .bind(this);

        this.state = {
            value: 'accountMemo'
        };
    }

    handleChange(value) {
        this.setState({ value: value });
    }

    render() {

        const {
            clearWorkOrderDetail,
            orderId,
            header,
            detailKey,
            workOrderActions,
            memoDetail
        } = this.props;

        let memosLoading = false;


        if (memoDetail) {
            memosLoading = memoDetail.get('loading');
        }


        return (
            <Panel
                loading={memosLoading}
                hasDetails={memoDetail && memoDetail.get('details') && memoDetail.get('details').count() > 0}
                orderId={orderId}
                detailKey={detailKey}
                clearWorkOrderDetail={clearWorkOrderDetail}
                header={header}>
                <Tabs onChange={this.handleChange} value={this.state.value}>
                    <Tab label="Account" onActive={this.updateHeight} value="accountMemo">
                        <CommentPanel
                            key="comment_panel"
                            detailKey="accountMemos"
                            header="Memos"
                            orderId={orderId}
                            memoDetail={memoDetail}
                            clearWorkOrderDetail={workOrderActions.clearWorkOrderDetail} />
                    </Tab>
                </Tabs>
            </Panel>
        );
    }
}

MemoPanel.propTypes = {
    memoDetail: PropTypes.object,
    clearWorkOrderDetail: PropTypes.func,
    orderId: PropTypes.string,
    header: PropTypes.string,
    detailKey: PropTypes.string,
    workOrderActions: PropTypes.object
};

export default MemoPanel;



// WEBPACK FOOTER //
// ./src/components/work-order/MemoPanel.js